import api from '../../../../utills/axiosConfig';

export const fetchSizes = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const { data } = await api.get('/sizes', { params });
  return data;
};

export const addSize = async (size) => {
  const { data } = await api.post('/sizes', size);
  return data;
};

export const updateSize = async (id, size) => {
  const { data } = await api.put(`/sizes/${id}`, size);
  return data;
};

export const deleteSize = async (id) => {
  const { data } = await api.delete(`/sizes/${id}`);
  return data;
};

export const importSizeCSV = async (formData) => {
  const { data } = await api.post('/sizes/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 